<ion-card-content class="ion-padding-horizontal-2 ion-padding-vertical-0">
    <app-single-project-select *ngIf="!to.multi" [scannedAsset]="projects[0]" [projectFormControl]="formControl"
        [props]="$any(props)" [key]="updatedKey" (projectsEvent)="saveProjects($event)">
    </app-single-project-select>

    <app-multi-project-select *ngIf="to.multi" [scannedAssets]="projects" [props]="$any(props)" [key]="updatedKey"
        (projectsEvent)="saveProjects($event)">
    </app-multi-project-select>

</ion-card-content>